import { Link } from "react-router-dom"

    export default function DatagridResumenUsuario({ data, title, month, year }) {

    const sede = data[0]?.Sede.slice(7)
    
    const dirWebApp = process.env.REACT_APP_DIR_PRO

    return (
      <div className="px-4 sm:px-6 lg:px-8 bg-primarioMira p-5 rounded-lg">
        <div className="sm:flex sm:items-center">
          <div className="sm:flex-auto">
            <h3 className="text-xl font-semibold text-white">Resumen por usuario</h3>
            <h4 className="text-xl font-semibold text-white">{title} - Sede {sede}</h4>
            <h5 className="text-xl font-semibold text-white">{month} {year}</h5>
            <p className="mt-2 text-sm text-grisMira">
              Tabla resumen de todas las transacciones realizadas por usuario por empresa y sede especifica.
            </p>
          </div>
          {/*<div className="mt-4 sm:mt-0 sm:ml-16 sm:flex-none">
            <button
              type="button"
              className="inline-flex items-center justify-center rounded-md border border-transparent bg-indigo-600 px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:w-auto"
            >
              Export
            </button>
          </div>*/}
        </div>
        <div className="mt-8 flex flex-col">
          <div className="-my-2 -mx-4 overflow-x-auto sm:-mx-6 lg:-mx-8">
            <div className="inline-block min-w-full py-2 align-middle lg:px-6">
              <div className="overflow-hidden shadow ring-1 ring-black ring-opacity-5 lg:rounded-lg">
                <table className="min-w-full divide-y divide-gray-300">
                  <thead className="bg-secundarioMira">
                    <tr>
                      <th
                        scope="col"
                        className="whitespace-nowrap py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-grisMira sm:pl-6 sr-only"
                      >
                        ID
                      </th>
                      <th
                        scope="col"
                        className="whitespace-nowrap px-2 py-3.5 text-left text-sm font-semibold text-white"
                      >
                        Usuario
                      </th>
                      <th
                        scope="col"
                        className="whitespace-nowrap px-2 py-3.5 text-left text-sm font-semibold text-grisMira"
                      >
                        Pagos en linea 
                      </th>
                      <th
                        scope="col"
                        className="whitespace-nowrap px-2 py-3.5 text-left text-sm font-semibold text-grisMira"
                      >
                        Agencias bancarias
                      </th>
                      <th
                        scope="col"
                        className="whitespace-nowrap px-2 py-3.5 text-left text-sm font-semibold text-grisMira"
                      >
                        Boletas
                      </th>
                      <th
                        scope="col"
                        className="whitespace-nowrap px-2 py-3.5 text-left text-sm font-semibold text-grisMira"
                      >
                        Efectivo
                      </th>
                      <th
                        scope="col"
                        className="whitespace-nowrap px-2 py-3.5 text-left text-sm font-semibold text-grisMira"
                      >
                        POS
                      </th>
                      <th
                        scope="col"
                        className="whitespace-nowrap px-2 py-3.5 text-left text-sm font-semibold text-white"
                      >
                        Total por usuario
                      </th>
                      <th scope="col" className="relative whitespace-nowrap py-3.5 pl-3 pr-4 sm:pr-6">
                        <span className="sr-only">Detalle</span>
                      </th>
                      <th scope="col" className="relative whitespace-nowrap py-3.5 pl-3 pr-4 sm:pr-6">
                        <span className="sr-only">Sedes</span>
                      </th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-white bg-secundarioMira">
                    {data.map((transaction, index) => (
                      <tr key={index + 1}>
                        <td 
                            className={`whitespace-nowrap py-2 pl-4 pr-3 text-sm sm:pl-6 ${index < (data.length - 1) ? 'text-grisMira' : 'text-center text-white font-medium'}`}
                            colSpan={index < (data.length - 1) ? 1 : 2}
                        >
                          {index < (data.length - 1) ? null : 'TOTAL'}
                        </td>
                        <td className={`whitespace-nowrap px-2 py-2 text-sm text-white ${index < (data.length - 1) ? null : 'hidden'}`}>
                          {index < (data.length - 1) ? transaction.Usuario : null}
                        </td>
                        <td className="whitespace-nowrap px-2 py-2 text-sm text-grisMira">{index < (data.length - 1) ? transaction.Cybersource : transaction.Total_Cybersource}</td>
                        <td className="whitespace-nowrap px-2 py-2 text-sm text-grisMira">{index < (data.length - 1) ? transaction.Bancos : transaction.Total_Bancos}</td>
                        <td className="whitespace-nowrap px-2 py-2 text-sm text-grisMira">{index < (data.length - 1) ? transaction.Boleta : transaction.Total_Boleta}</td>
                        <td className="whitespace-nowrap px-2 py-2 text-sm text-grisMira">{index < (data.length - 1) ? transaction.Efectivo : transaction.Total_Efectivo}</td>
                        <td className="whitespace-nowrap px-2 py-2 text-sm text-grisMira">{index < (data.length - 1) ? transaction.POS : transaction.Total_POS}</td>
                        <td className="whitespace-nowrap px-2 py-2 text-sm text-white">{index < (data.length - 1) ? transaction.Totales : transaction.Total_Totales}</td>
                        <td className="whitespace-nowrap px-2 py-2 pr-4 text-sm font-medium sm:pr-6">
                          <Link
                           to={`${dirWebApp}contabilidad_reportes/detalle`}
                           state={{ IdEmp: transaction.IdEmp, sedes: transaction.CobrosEnMasSedes, IdSede: transaction.IdSede, month: month, year: year, option: '4' }}
                           className={`text-secundario hover:underline ${index < (data.length - 1) ? null : 'hidden'}`}>
                            Detalle<span className="sr-only">, {index + 1}</span>
                          </Link>
                        </td>
                        <td className="whitespace-nowrap px-2 py-2 pr-4 text-sm font-medium sm:pr-6">
                          <Link
                           to={`${dirWebApp}contabilidad_reportes/detalle`}
                           state={{ IdEmp: transaction.IdEmp, sedes: transaction.CobrosEnMasSedes, IdSede: transaction.IdSede, month: month, year: year, option: '5', TotalUsuario: transaction.Totales }}
                           className={`text-green-500 hover:underline ${index < (data.length - 1) ? null : 'hidden'}`}>
                            Resumen<span className="sr-only">, {index + 1}</span>
                          </Link>
                        </td>
                        <td className="relative whitespace-nowrap py-2 pl-3 pr-4 text-right text-sm font-medium sm:pr-6">
                          <Link 
                           to={`${dirWebApp}contabilidad_reportes/detalle`}
                           state={{ IdEmp: transaction.IdEmp, sedes: transaction.CobrosEnMasSedes, month: month, year: year }}
                           className={`text-indigo-600 hover:underline ${index < (data.length - 1) ? (transaction.CobrosEnMasSedes ? null : 'hidden') : 'hidden'}`}>
                            Sedes<span className="sr-only">, {index + 1}</span>
                          </Link>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
  